
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const app = this.$app;
    }
  },
  id: '22e18c5563',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page pathlab-page" data-name="pathlab">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Diagnosis</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <!-- Inline sticky search (matches home hero style) -->\n            <div class="pathlab-search-wrap">\n                <form data-search-container=".labs-grid" data-search-in=".lab-card-name,.lab-card-address" class="searchbar searchbar-inline searchbar-pathlab searchbar-init">\n                    <div class="searchbar-inner">\n                        <div class="searchbar-input-wrap">\n                            <i class="icon f7-icons if-not-md mdoc-sb-icon">search</i>\n                            <i class="icon material-icons md-only mdoc-sb-icon">search</i>\n                            <input type="search" placeholder="Search labs by name or area\u2026">\n                            <span class="input-clear-button"></span>\n                        </div>\n                    </div>\n                </form>\n            </div>\n\n            <!-- Page intro -->\n            <div class="pathlab-intro">\n                <div class="pathlab-intro-title">Book lab tests at trusted partners</div>\n                <div class="pathlab-intro-sub">Pick a lab to see its tests and book a slot.</div>\n            </div>\n\n            <!-- Labs grid -->\n            <div class="labs-grid searchbar-found">\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <a href="/pathlab-tests/';
          r += c(ctx_2.id, ctx_2);
          r += '/" class="lab-card link" aria-label="';
          r += c(ctx_2.name, ctx_2);
          r += '">\n                    <div class="lab-card-image">\n                        <img src="';
          r += c(ctx_2.image_url, ctx_2);
          r += '" alt="" onerror="this.src=\'static/img/default_hospital.svg\'">\n                    </div>\n                    <div class="lab-card-body">\n                        <div class="lab-card-name">';
          r += c(ctx_2.name, ctx_2);
          r += '</div>\n                        ';
          r += Template7Helpers.js_if.call(ctx_2, 'this.address', {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <div class="lab-card-address">\n                            <i class="icon f7-icons if-not-md">placemark</i>\n                            <i class="icon material-icons md-only">place</i>\n                            <span>';
              r += c(ctx_3.address, ctx_3);
              r += '</span>\n                        </div>\n                        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        <div class="lab-card-cta">\n                            <span>View tests</span>\n                            <i class="icon f7-icons if-not-md">arrow_right</i>\n                            <i class="icon material-icons md-only">arrow_forward</i>\n                        </div>\n                    </div>\n                </a>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No labs in your area yet</div>\n                <div class="empty-state-sub">We\'re partnering with new labs every week \u2014 check back soon.</div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <!-- Not-found (search) -->\n            <div class="empty-state searchbar-not-found">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No labs match your search</div>\n                <div class="empty-state-sub">Try a different name or area.</div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    